<template>
    <p>
        <svg
            id="ecmSX3QHYT21"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 90 90"
            shape-rendering="geometricPrecision"
            text-rendering="geometricPrecision"
        >
            <g
                id="ecmSX3QHYT22"
                transform="translate(13.061055 30.839711)"
                opacity="0"
            >
                <path
                    d="M37.1971,26.4061c.7947-1.0136,1.1758-2.1003,1.1272-3.2193-.0487-1.2326-.6001-2.1976-1.0542-2.7896.5271-1.3137.7298-3.3815-1.0299-4.9871-1.2894-1.1759-3.4788-1.703-6.5117-1.557-2.1327.0973-3.9167.4947-3.9897.5109h-.0081c-.4055.073-.8352.1622-1.2731.2595-.0325-.519.0567-1.8084,1.0136-4.71145c1.1353-3.45451,1.0704-6.0981-.2108-7.8659-1.3461-1.857002-3.4951-2.002968-4.1276-2.002968-.6082,0-1.1677.251385-1.5651.713608-.9001,1.04608-.7947,2.97607-.6811,3.86808-1.0704,2.87064-4.0708,9.90943-6.609,11.86373-.0487.0324-.0892.073-.1298.1135-.746.7866-1.2488,1.6381-1.5894,2.3841-.4784-.2595-1.02171-.4054-1.60557-.4054h-4.9466c-1.86511,0-3.373418,1.5164-3.373418,3.3734v13.1774c0,1.8651,1.516418,3.3734,3.373418,3.3734h4.9466c.72171,0,1.39477-.2271,1.94617-.6163l1.9057.2271c.2919.0405,5.4818.6973,10.8095.5919.965.073,1.8732.1136,2.7166.1136c1.4515,0,2.7166-.1136,3.7708-.3406c2.4814-.5271,4.1762-1.5813,5.0358-3.1302.6568-1.1839.6568-2.3597.5514-3.1058c1.6137-1.4596,1.8975-3.0734,1.8408-4.2086-.0325-.6569-.1784-1.2164-.3325-1.63ZM4.00623,36.3155c-.65684,0-1.18394-.5352-1.18394-1.1839v-13.1855c0-.6569.53521-1.184,1.18394-1.184h4.9466c.65684,0,1.18397.5352,1.18397,1.184v13.1774c0,.6568-.53524,1.1839-1.18397,1.1839h-4.9466v.0081ZM35.1211,25.4573c-.3406.3568-.4054.9002-.1459,1.3218c0,.0081.3324.5758.373,1.3543.0568,1.0623-.4541,2.0029-1.5245,2.8057-.3812.292-.5352.7947-.3731,1.2489c0,.0081.3487,1.0785-.2189,2.0921-.5433.9731-1.7516,1.6705-3.5843,2.0598-1.4677.3162-3.4626.373-5.9115.1784-.0325,0-.073,0-.1136,0-5.2142.1135-10.4851-.5677-10.5419-.5758h-.0081l-.819-.0973c.0486-.2271.0729-.4703.0729-.7136v-13.1855c0-.3487-.0567-.6893-.154-1.0056.1459-.5433.5514-1.7516,1.5083-2.7814c3.641-2.8869,7.2009-12.62601,7.355-13.04768.0649-.1703.0811-.35681.0487-.54332-.1379-.90823-.0893-2.01918.1054-2.35166.4298.00811,1.5894.12975,2.2868,1.09474.8271,1.14339.7947,3.18691-.0974,5.89537-1.3623,4.12755-1.4758,6.30085-.3973,7.25775.5352.4784,1.2488.5027,1.7678.3162.4947-.1135.965-.2108,1.411-.2838.0324-.0081.073-.0162.1054-.0243c2.4895-.5433,6.9496-.8758,8.4984.5352c1.3137,1.2001.3812,2.7895.2757,2.9598-.3.4541-.2108,1.0461.1947,1.411.0081.0081.8595.8109.9001,1.8895.0324.7217-.3082,1.4596-1.0137,2.1894Z"
                />
                <path
                    d="M4.00718,36.3241c-.65684,0-1.18394-.5352-1.18394-1.1839v-13.1855c0-.6569.53521-1.184,1.18394-1.184h4.9466c.65684,0,1.18392.5352,1.18392,1.184v13.1774c0,.6568-.53519,1.1839-1.18392,1.1839h-4.9466v.0081ZM35.1221,25.4659c-.3406.3568-.4055.9002-.146,1.3218c0,.0081.3325.5758.373,1.3543.0568,1.0623-.4541,2.0029-1.5245,2.8057-.3811.292-.5352.7947-.373,1.2488c0,.0082.3487,1.0786-.219,2.0922-.5433.9731-1.7515,1.6705-3.5842,2.0597-1.4678.3163-3.4626.3731-5.9116.1784-.0324,0-.073,0-.1135,0-5.2142.1136-10.4852-.5676-10.542-.5757h-.0081l-.819-.0973c.0487-.2271.073-.4703.073-.7136v-13.1855c0-.3487-.0568-.6893-.1541-1.0056.146-.5433.5514-1.7516,1.5083-2.7814c3.641-2.8869,7.201-12.62601,7.355-13.04769.0649-.17029.0811-.3568.0487-.54331-.1379-.90823-.0892-2.01919.1054-2.35166.4298.00811,1.5894.12974,2.2868,1.09474.8271,1.14339.7947,3.1869-.0973,5.89537-1.3623,4.12755-1.4759,6.30085-.3973,7.25775.5352.4784,1.2488.5027,1.7678.3162.4946-.1135.9649-.2108,1.4109-.2838.0325-.0081.073-.0162.1055-.0243c2.4895-.5433,6.9495-.8758,8.4984.5352c1.3137,1.2001.3811,2.7895.2757,2.9598-.3.4541-.2108,1.0461.1946,1.411.0081.0081.8596.8109.9001,1.8895.0325.7217-.3081,1.4596-1.0136,2.1894Z"
                    fill="#fdfcf8"
                />
            </g>
        </svg>
    </p>
</template>
<script>
export default {
    name: 'Thumb',
    // https://www.svgator.com/help/getting-started/add-animated-svg-to-vue-js
    mounted() {
        (function (s, i, u, o, c, w, d, t, n, x, e, p, a, b) {
            (a = document.getElementById(i.root)).svgatorPlayer = {
                ready: (function (a) {
                    b = [];
                    return function (c) {
                        return c ? (b.push(c), a.svgatorPlayer) : b;
                    };
                })(a),
            };
            w[o] = w[o] || {};
            w[o][s] = w[o][s] || [];
            w[o][s].push(i);
            e = d.createElementNS(n, t);
            e.async = true;
            e.setAttributeNS(
                x,
                'href',
                [u, s, '.', 'j', 's', '?', 'v', '=', c].join(''),
            );
            e.setAttributeNS(
                null,
                'src',
                [u, s, '.', 'j', 's', '?', 'v', '=', c].join(''),
            );
            p = d.getElementsByTagName(t)[0];
            p.parentNode.insertBefore(e, p);
        })(
            '91c80d77',
            {
                root: 'ecmSX3QHYT21',
                version: '2022-05-04',
                animations: [
                    {
                        elements: {
                            ecmSX3QHYT22: {
                                transform: {
                                    data: {
                                        o: {
                                            x: 13.693867,
                                            y: 69.661011,
                                            type: 'corner',
                                        },
                                        t: { x: -0.632812, y: -38.8213 },
                                    },
                                    keys: {
                                        r: [
                                            { t: 0, v: 360 },
                                            { t: 300, v: 340 },
                                            { t: 600, v: 359 },
                                            { t: 900, v: 380 },
                                            { t: 1200, v: 340 },
                                            { t: 1500, v: 359 },
                                        ],
                                        s: [
                                            { t: 300, v: { x: 1, y: 1 } },
                                            {
                                                t: 900,
                                                v: { x: 1.5, y: 1.5 },
                                                e: [1, 0.265, 1, 0.52],
                                            },
                                        ],
                                    },
                                },
                                opacity: [
                                    { t: 200, v: 0 },
                                    { t: 300, v: 1 },
                                    { t: 2700, v: 1 },
                                    { t: 3000, v: 0 },
                                ],
                            },
                        },
                        s: 'MDLA1MzhhMzFYNSzM4NDgxNzA4JMzc4N2U3ZDMYxNDk0MjNmM2DYzZjNiMzE3MDzc4ODE3NDcyAODM3ODdlN2QAzMTQ5NDAzYjEMxNzg4Mzc0OVDE3MDgzNzg3EZTdkODIzMTQK5NDAzYjMxWTQc1Nzg3YjdiMHzE0OTQwM2IzXMTcwN2I4MzcC0ODFWN2Q3MEJo4Mzc0MzE0OETc1NzA3YjgyYNzQzYjMxODIO3Zjc0NzQ3MzCMxNDk0MDhj',
                    },
                ],
                options:
                    'MDJAxMDgyMjk3YGTdiNjg3OTdiTMjk0MTI5NzMU3NjY4NmIyOVTE4NA|',
            },
            'https://cdn.svgator.com/ply/',
            '__SVGATOR_PLAYER__',
            '2022-05-04',
            window,
            document,
            'script',
            'http://www.w3.org/2000/svg',
            'http://www.w3.org/1999/xlink',
        );
    },
};
</script>
